import { Navigate } from 'react-router-dom';

// const PrivateRoute = ({ element, isLoggedIn, ...rest }) => {
//   return isLoggedIn ? <Route {...rest} element={element} /> : <Navigate to="/login" />;
// };
const PrivateRoute = ({ isLoggedIn, children }) => {
  return isLoggedIn ? children : <Navigate to="/login" replace />;
};


export default PrivateRoute;
